import { render, staticRenderFns } from "./DelegateDocuments.vue?vue&type=template&id=7d0d62dc"
import script from "./DelegateDocuments.vue?vue&type=script&lang=ts"
export * from "./DelegateDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports